import React, { useRef, useState } from 'react';
import './footer.style.scss';
import { ReduxState, TextDirection } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { __SLPFooterProps } from './footer.interface';
import ucheckLogo from 'assets/images/logo/logo-white.png';
import { setKioskData } from 'redux/actions';
import { kioskCode, kioskData } from 'scripts/storage';
import useOnBlur from 'scripts/useOnBlur';
import { Modal } from 'react-bootstrap';
import SLPPhoneNumber from 'utilities/slp/phone/phone.index';
import SLPButton from 'utilities/slp/button/button.index';
import { toast } from 'react-toastify';

const SLPFooter: React.FC<ConnectedProps<typeof connector> & __SLPFooterProps> = function (
    props: ConnectedProps<typeof connector> & __SLPFooterProps,
) {
    const lang = props.lang.SLP;
    const [show, setShow] = useState(false);
    const [code, setCode] = useState('');
    const logoContainer = useRef<HTMLAnchorElement>(null);
    const divContainer = useRef<HTMLDivElement>(null);
    let length = 0;
    props.form?.sections.forEach((section) => {
        length += section.questions.length;
    });
    const logoutCounter = useRef(0);
    let questionIndex = 0;
    let questionTransaction = false;
    if (props.question && props.form) {
        props.form.sections
            .sort((a, b) => a.order - b.order)
            .forEach((section) => {
                section.questions
                    .sort((a, b) => a.order - b.order)
                    .forEach((question) => {
                        if (!questionTransaction) questionIndex += 1;
                        if (question.id === props.question?.id) questionTransaction = true;
                    });
            });
    }

    useOnBlur(logoContainer, () => {
        logoutCounter.current = 0;
    });
    useOnBlur(divContainer, () => {
        logoutCounter.current = 0;
    });

    const iconClick = () => {
        if (props.kiosk || props.portal) {
            logoutCounter.current = logoutCounter.current + 1;
            if (logoutCounter.current === 10) {
                props.onLogoClick ? props.onLogoClick() : setShow(true);
            }
        }
    };

    return (
        <div className="ucheck-slp-footer">
            {props.cover && <div className="go-to-premium d-none d-lg-flex">{lang.premium}</div>}
            <Modal
                onHide={() => setShow(false)}
                show={show}
                className={`ucheck-kiosk-logout-modal`}
                size={'lg'}
                centered
            >
                <div className="d-flex flex-column modal-container">
                    <i onClick={() => setShow(false)} className="material-icons close-icon">
                        close
                    </i>
                    <p>{lang.kioskLogout}</p>
                    <SLPPhoneNumber
                        value={code}
                        onChange={(e) => {
                            if (e !== undefined) setCode(e);
                        }}
                        placeholder=""
                    />
                    <SLPButton
                        onClick={() => {
                            if (Number(code) === kioskCode.get()) {
                                kioskData.remove();
                                kioskCode.remove();
                                props.dispatch(setKioskData(null));
                            } else toast.error(lang.wrongCodeErr);
                        }}
                    >
                        {lang.logout}
                    </SLPButton>
                </div>
            </Modal>
            {!props.hide ? (
                <div dir={props.form?.direction === TextDirection.ltr ? 'ltr' : 'rtl'} className="slp-footer">
                    <div>
                        <a ref={logoContainer} onClick={iconClick}>
                            <img src={ucheckLogo} alt="logo" />
                        </a>
                    </div>
                </div>
            ) : (
                <div ref={divContainer} className={`hide-div ${props.kiosk ? '' : 'd-none'}`} onClick={iconClick} />
            )}
            {/* <>
            {!questionIndex ? (
                <div className="create-new-form">
                    <h4>{props.form?.lang === Language.fa ? lang.createTxt : lang.createTxtEN}</h4>
                    <SLPButton href={UCheckPath.panel} className="d-none d-md-flex">
                        {props.form?.lang === Language.fa ? lang.create : lang.createEN}
                    </SLPButton>
                    <i className="ufi ufi-plus d-md-none" />
                </div>
            ) : (
                <div className="form-tools">
                    <h5>
                        {questionIndex}/{length}
                    </h5>
                    <span className="progress-bar">
                        <span style={{ width: (questionIndex / length) * 100 + '%' }} className="filled"></span>
                    </span>
                    <button
                        onClick={() => props.onPrev()}
                        disabled={questionIndex === 1}
                        className={`ufi ufi-chevron-${
                            props.form?.direction === TextDirection.rtl ? 'right' : 'left'
                        } d-none d-md-flex`}
                    />
                    <button
                        onClick={() => props.onNext()}
                        disabled={questionIndex === length}
                        className={`ufi ufi-chevron-${
                            props.form?.direction === TextDirection.rtl ? 'left' : 'right'
                        }  d-none d-md-flex`}
                    />
                </div>
            )}
            </> */}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
    kiosk: state.kioskData,
    portal: state.portalPublishData,
});

const connector = connect(mapStateToProps);
export default connector(SLPFooter);
